import { Entity } from 'app/types-shared';
import { InitialUiEngineProps, ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { getEntityTypeFromStorePath } from 'app/infrastructure/store/entity';
import { tableName } from 'app/area/case/case-data-model';
import get from 'lodash/get';
import { ComplexValue } from 'app/infrastructure/ui/form/types';
import { invariant } from 'app/infrastructure/log';

export function entityFilter(entity: Entity, props: InitialUiEngineProps | ConnectedComponentProps): boolean {
  const childEntityType = getEntityTypeFromStorePath(entity.id);
  const primaryKey = get(props, 'resolveContext.primaryKey');
  switch (childEntityType) {
    case tableName.causes:
      return contextCategoryEqualsPkCategory(entity, primaryKey);
    case tableName.green:
      return contextCategoryEqualsFieldNameValue('EnvValSubstance', entity, primaryKey);
    default:
      return true;
  }
}

function contextCategoryEqualsPkCategory(entity: Entity, contextPrimaryKey: ComplexValue<number>) {
  invariant(!!contextPrimaryKey, 'invalid primary key');
  invariant(!!entity.primaryKey, 'invalid primary key');

  return entity.primaryKey && entity.primaryKey.categoryId === contextPrimaryKey.value;
}

function contextCategoryEqualsFieldNameValue(fieldName: string, entity: Entity, contextPrimaryKey: ComplexValue<number>) {
  invariant(!!contextPrimaryKey, 'invalid context primary key');
  invariant(!!entity[fieldName], `field name ${fieldName} is not a property on entity`);
  invariant(Array.isArray(entity[fieldName]) && !!entity[fieldName][0], 
    `${fieldName}: ${JSON.stringify(entity[fieldName])} is not a valid value`);

  return entity[fieldName] && entity[fieldName][0].categoryId === contextPrimaryKey.value;
}
